// §10.6: state-aware header actions. Reopen never appears alongside
// Mark won / Mark lost — the spec is explicit.

import React from 'react';
import { Button } from '../../../ui';

interface Props {
  isOpen: boolean;
  disabled?: boolean;
  onMarkWon: () => void;
  onMarkLost: () => void;
  onReopen: () => void;
}

const DealActionButtons: React.FC<Props> = ({
  isOpen,
  disabled = false,
  onMarkWon,
  onMarkLost,
  onReopen,
}) => {
  if (isOpen) {
    return (
      <div className="flex items-center gap-2">
        <Button
          intent="danger"
          size="sm"
          onClick={onMarkLost}
          disabled={disabled}
        >
          Mark lost
        </Button>
        <Button
          intent="primary"
          size="sm"
          onClick={onMarkWon}
          disabled={disabled}
        >
          Mark won
        </Button>
      </div>
    );
  }
  return (
    <Button intent="primary" size="sm" onClick={onReopen} disabled={disabled}>
      Reopen
    </Button>
  );
};

export default DealActionButtons;
